import SingleClientReportEntriesTable from './SingleClientReportEntriesTable';

export default SingleClientReportEntriesTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client/form/table/index.js